export default "__VITE_ASSET__7550e1c0__"